module.exports = __webpack_public_path__ + "static/img/title-advantage.7e9350a2.png";